export default __webpack_public_path__ + "static/bg-inspiration-e817309b6b9155c29e9e5b347aeaa8bb.png";